export const dispatchChannel = {
  AUTH: 'auth'
};

export const dispatchEvent = {
  SIGNED_IN: 'signedIn'
};
